import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import { useFetch } from '../../core/http/fetch.hook';

export const secondsToMinutes = (seconds: number | undefined) => ((seconds !== undefined)
  ? Math.round(seconds / 60)
  : 0)


const CounterScreen: React.FC = () => {

  const [minutes, setMinutes] = useState<number>()
  // console.log('minutes', minutes)
  const { response: statistics } = useFetch('statistics/global')

  useEffect(() => {
    if (statistics !== undefined) {
      console.log('statistics', statistics)
      const { seconds } = statistics
      setMinutes(secondsToMinutes(seconds))
    }

  }, [statistics])

  return (
    <>
      <div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15, marginTop: 48 }}>
          <img width={76} height={76} src={"images/app-icon.png"} />
          <div className="CalculatorTitle"style={{ maxWidth: 400, padding: 32, fontSize: 16, lineHeight: 1.2 }}>
          Минуты медитации всех пользователей начиная с 18.08.2026. 00.00 по 24.08.2026 по Москве
          <p className="CalculatorSubitle" style={{padding: 32, fontSize: 48}}>{minutes || '-'}</p>
        </div>
        </div>
        <Footer
          showSellerInfo={false}
          backgroundColor={'transparent'}
          textColor={'#000'}
          linkColor={'#33B49D'}
        />
      </div >
    </>
  );
}

export default CounterScreen;
